import {useEffect} from "react";

import {useSelector} from "react-redux";

import SaveStatus from '../../UIComponents/SaveStatus'
import LinkList from "../../UIComponents/LinkList";

import mapStateToProps from './mapStateToProps'
import {storageKeys} from "../../shared/constants/storageKeys";
import {useDirectoryList} from "../../Hooks/useDirectoryList/useDirectoryList";
import {useHistory, useParams} from "react-router-dom";

const DirectoryList = () => {
    const {
        getDirectoryList = () => {},
        directoryList,
        directoryList: {
            data: listFull= []
        }= {},
        rights={},
    } = useSelector(mapStateToProps);

    const { dirname } = useParams();
    const history = useHistory();
    const list = useDirectoryList(storageKeys.DIRECTORY_LIST, getDirectoryList, listFull, rights)

    useEffect(() => {
        if (!list?.length)  return
        // если не открыт ни 1 справочник, открыть первый !!!
        if (!dirname) {
            history.push(`/directory/${list[0]?.id}`)
        }
    }, [list?.length, dirname])

    return (
        <>
            <SaveStatus title="Загрузка списка справочников" dataObj={directoryList} successShowTime={100}/>
            <LinkList
                linkArr={list.map(({id, name})=> (
                    {
                        link:`/directory/${id}`,
                        selected: (id === dirname),
                        label: name
                    }
                ))}
            />
        </>
    )
}

export default DirectoryList;